import express, { Router } from 'express';

import * as paymentPlanValidation from '@/modules/paymentPlan/paymentPlan.validation';
import * as paymentPlanController from '@/modules/paymentPlan/paymentPlan.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.PAYMENTPLAN, ACTIONS.READ),
    validateMiddleware(paymentPlanValidation.getPaymentPlan),
    paymentPlanController.getPaymentPlans,
  )
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.PAYMENTPLAN, ACTIONS.CREATE),
    validateMiddleware(paymentPlanValidation.createPaymentPlan()),
    setAuditFields({ mode: AuditMode.CREATE, companyField: 'companyId' }),
    paymentPlanController.createPaymentPlan,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(
      MODULE_LIST.PAYMENTPLAN,
      ACTIONS.READ,
    ),
    validateMiddleware(paymentPlanValidation.getPaymentPlanById),
    paymentPlanController.getPaymentPlanById,
  )
  .patch(
    userAuthAndCheckPermissions(
      MODULE_LIST.PAYMENTPLAN,
      ACTIONS.UPDATE,
    ),
    validateMiddleware(paymentPlanValidation.updatePaymentPlan()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    paymentPlanController.updatePaymentPlan,
  )
  .delete(
    userAuthAndCheckPermissions(
      MODULE_LIST.PAYMENTPLAN,
      ACTIONS.DELETE,
    ),
    validateMiddleware(paymentPlanValidation.deletePaymentPlanById),
    paymentPlanController.deletePaymentPlanById,
  );

export default router;
